<template>
	<v-layout column align-center class="content-pad-vert">
		<v-flex x12 sm10 md8 offset-sm-1 offset-md-2 class="pt-5">
			<div>
				<h1>Team page is WIP!</h1>
				<h4>Check back in later!</h4>

				<router-link :to="{ name: 'dashboard' }">Go back to the dashboard</router-link>
			</div>
		</v-flex>
	</v-layout>
</template>
<script>
export default {
	name: 'team',
	data() {
		return {
			message: 'nothing'
		}
	}
}
</script>
<style>
</style>
